/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState, { metaInitialState } from './initialState';
var updateExperimentInfo = produce(function (draft, action) {
  var _action$payload = action.payload,
    experimentId = _action$payload.experimentId,
    experimentName = _action$payload.experimentName,
    sampleIds = _action$payload.sampleIds,
    parentExperimentId = _action$payload.parentExperimentId,
    pipelineVersion = _action$payload.pipelineVersion,
    accessRole = _action$payload.accessRole,
    excludeGenes = _action$payload.excludeGenes,
    modalities = _action$payload.modalities;
  draft.info.experimentId = experimentId;
  draft.info.experimentName = experimentName;
  draft.info.sampleIds = sampleIds;
  draft.info.parentExperimentId = parentExperimentId;
  draft.info.pipelineVersion = pipelineVersion;
  draft.info.accessRole = accessRole;
  draft.info.excludeGenes = excludeGenes;
  draft.info.modalities = modalities;
  if (draft.info.experimentId !== experimentId) {
    // Experiment id was updated so processing config requires reloading
    draft.processing = {
      meta: metaInitialState
    };
  }
}, initialState);
export default updateExperimentInfo;